import { useController } from "react-hook-form";

interface Props {
  name: string;
  options: Array<{ label: string; value: string | number }>;
  required?: boolean;
  defaultValue: string | number;
}

const RadioButtonGroup = ({ name, options, required, defaultValue }: Props) => {
  const { field } = useController({ name, rules: { required }, defaultValue });

  const onChange = (value: string | number) => {
    field.onChange(value);
    field.onBlur();
  };

  return (
    <ul className="flex gap-[0.313rem]">
      {options.map((option) => (
        <li key={option.value}>
          <label className="relative">
            <input
              type="radio"
              className="absolute w-0 h-0 opacity-0 cursor-pointer peer"
              checked={field.value === option.value}
              onChange={() => {
                onChange(option.value);
              }}
            />
            <span className="h-9 w-[3.313rem] inline-flex justify-center items-center rounded-md text-14 text-secondary border border-secondary bg-white peer-checked:bg-secondary peer-checked:text-white">
              {option.label}
            </span>
          </label>
        </li>
      ))}
    </ul>
  );
};

export default RadioButtonGroup;
